import { render, staticRenderFns } from "./CibusIcon.vue?vue&type=template&id=1b1a8908&"
import script from "./CibusIcon.vue?vue&type=script&lang=js&"
export * from "./CibusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports